import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { fadeAnimation } from '../animations/fade-animation';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    animations: [fadeAnimation]
})
export class MainNavComponent implements OnInit, OnDestroy {

    @ViewChild('drawer') sideNav: MatSidenav;
    private routeSubscription: Subscription;
    private handsetSubscription: Subscription;
    private isHandset: boolean;

    email: string;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(private breakpointObserver: BreakpointObserver,
        private router: Router) {}

    ngOnInit() {
        this.email = 'andreas@bavarianbits.de';

        this.isHandset = false;

        this.handsetSubscription = this.isHandset$.subscribe(handset => {
            if(handset) {
                this.isHandset = true;
            } else {
                this.isHandset = false;
            }
        })

        this.routeSubscription = this.router.events.subscribe(event => {
            if(this.isHandset)
                this.sideNav.close();
        });
    }

    ngOnDestroy() {
        this.handsetSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }
}
